import React from "react";

import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

import type { ReactPortal } from "react";

interface EditModeCoolBorderProps {
  isEditMode: boolean;
}

export default function EditModeCoolBorder({
  isEditMode,
}: EditModeCoolBorderProps): ReactPortal | null {
  const { t } = useTranslation("editor-fast-channel");
  const layoutContainer = document.getElementById("fast-layout-container");

  if (!isEditMode || !layoutContainer) return null;

  return createPortal(
    <div className="border-destructive pointer-events-none absolute inset-0 overflow-visible border-4">
      <div className="bg-destructive text-primary-foreground absolute top-0 left-full -translate-x-full rounded-bl-lg px-[1.09375rem] py-[0.625rem] whitespace-nowrap">
        {t("editModeActivated")}
      </div>
    </div>,
    layoutContainer,
  );
}
